import Image from 'next/image';
import React from 'react';

type Props = {
    path: string;
    darkPath?: string;
    alt: string;
    title: string;
    width: number;
    height: number;
    darkWidth?: number;
    darkHeight?: number;
};

const CarouselItem: React.FC<Props> = ({ path, alt, title, width, height, darkPath, darkWidth, darkHeight }) => {
    const hasDark = typeof darkPath === 'string' && darkPath.trim() !== '';

    return (
        <div className="project-logo">
            {/* show light logo; hide it in dark mode only if a dark logo exists */}
            <Image
                src={path}
                width={width}
                height={height}
                alt={alt}
                title={title}
                className={`img-fluid block ${hasDark ? 'dark:hidden' : ''}`}
                loading="lazy"
            />

            {/* render dark logo only when provided; it appears in dark mode */}
            {hasDark && (
                <Image
                    src={darkPath as string}
                    width={darkWidth || width}
                    height={darkHeight || height}
                    alt={alt}
                    title={title}
                    className="img-fluid hidden dark:block"
                    loading="lazy"
                />
            )}
        </div>
    );
};

export default CarouselItem;
